import { IconButton } from "@telluscompany/design-system";
import { ChevronLeft } from "lucide-react";
import { useLocalization } from "@i18n";
import { NavLink, Outlet, useNavigate } from "react-router-dom";

const ManagementHomePage = () => {
  const { translate } = useLocalization();
  const navigate = useNavigate();

  const tabs = [
    { label: translate("management.navbar.users"), value: "users" },
    { label: translate("management.navbar.clients"), value: "clients" },
    { label: translate("management.navbar.complexes"), value: "complexes" },
    { label: translate("management.navbar.structures"), value: "structures" },
    { label: translate("management.navbar.licenses"), value: "licenses" },
    // { label: translate("management.navbar.log"), value: "log" }, // Preterido para a primeira versão, já que não é uma feature tão crítica quanto os outras
    // { label: translate("management.navbar.releaseNotes"), value: "releaseNotes" }, // Preterido para a primeira versão, já que não é uma feature tão crítica quanto os outras
    { label: translate("management.navbar.termsOfUse"), value: "termsOfUse" },
    { label: translate("management.navbar.privacyPolicy"), value: "privacyPolicy" },
  ];

  return (
    <div className="p-8 min-h-full">
      <div className="flex items-center mb-4 gap-8">
        <IconButton
          className="bg-background-1 border border-border-1"
          icon={<ChevronLeft className="text-foreground-1" strokeWidth={2.5} />}
          size="medium"
          variant="squared"
          onClick={() => navigate("/")}
        />
        <h4 className="text-h4 ml-4">{translate("management.navbar.management")}</h4>
      </div>

      {/* Custom Tabs using NavLink */}
      <div className="mb-3">
        <nav className="flex gap-1">
          {tabs.map((tab) => (
            <NavLink
              key={tab.value}
              to={`/management/${tab.value}`}
              className={({ isActive }) =>
                `px-4 py-2 text-sm font-medium border-b-2 transition-colors ${
                  isActive
                    ? "border-primary text-primary"
                    : "border-transparent text-foreground-2 hover:text-foreground-1 hover:border-border-2"
                }`
              }
            >
              {tab.label}
            </NavLink>
          ))}
        </nav>
      </div>

      {/* Content area with transition */}
      <div className="transition-opacity duration-300">
        <Outlet />
      </div>
    </div>
  );
};

export default ManagementHomePage;
